import { Button, ButtonLoader } from "../../components/Button"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import ModalAlert from "../../components/ModalAlert"
import { Grid } from "../../components/Table"

export const RemoveAssistanceScreen = ({
  changeOptions,
  selectedOptions,
  modalIsOpen,
  handleOpenModal,
  handleCloseModal,
  handleRemove
}) => {
  const rows = [
    {
      id: "assistance",
      label: "Atendimento",
      width: "80px",
    },
    {
      id: "event",
      label: "Evento",
      width: "80px",
    },
  ]

  const columns = [
    {
      id: "checkbox",
      field: "checkbox",
    },
    {
      id: "remove",
      field: "label",
      label: "Tipo de remoção",
    },
  ]

  return (
    <div>
      <Button label="Remover" color="orange" handleClick={handleOpenModal} />
      <ModalPanel modalIsOpen={modalIsOpen}>
        <ModalHeader closeModal={handleCloseModal} title="Remover Atendimento" />
        <ModalBody>
          <div className="modal-buttons-group">
            <Grid
              rows={rows}
              columns={columns}
              isPaginated={false}
              onSelectedRowsChange={changeOptions}
              selectedRowsIds={selectedOptions}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonLoader
            label="Remover"
            color="orange"
            handleClick={() => {
              ModalAlert.warn({
                title: "Deseja remover este atendimento?",
                confirmLabel: "Sim",
                onConfirm: () => handleRemove(),

              })
            }}
            isDisabled={!selectedOptions.length}
          />
        </ModalFooter>
      </ModalPanel>
    </div>
  )
}